(function ($) {
	if (!$('body').hasClass('woocommerce-checkout')) {
		return;
	}

	class W4D_Checkout {
		constructor() {
			this.initSelectors();
			this.bindEvents();
			this.checkValidation();
		}

		initSelectors() {
			this.form = $('form.checkout');
			this.$header = $('.w4d-header');
			this.checkoutForm = $('.checkout.woocommerce-checkout');
			this.mediaQueryLg = window.matchMedia('(max-width: 1200px)');

			// Navigation and tabs
			this.checkoutTabs = $('[data-js-checkout-tabs]');
			this.checkoutTabLinks = this.checkoutTabs.find('button');
			this.checkoutTabsContentWrapper = $('[data-js-checkout-tabs-content-wrapper]');
			this.$checkoutStepTitle = $('.checkout__step-title');

			// Order Summary
			this.orderSummary = $('.order-summary, .sticky-bar');
			this.$orderSummaryToggle = $('[data-js="order-summary-details-btn"]');
			this.$orderSummaryDetails = $('[data-js="order-summary-details"]');

			// Buttons
			this.$cartToggleBtn = $('#js-toggle-cart-details');
			this.$summaryToggleBtn = $('.js-toggle-summary');
			this.$summaryCloseBtn = $('.js-close-summary');
			this.$editCustomerBtn = $('.js-edit-customer-data');
			this.$editDeliveryBtn = $('.js-edit-delivery');
			this.$editPaymentBtn = $('.js-edit-payment');
			this.$removeCouponBtn = $('.remove_coupon');
			this.$nextStepBtn = '[data-js-next-step]';
			this.$summaryBtn = $('[data-js-toggle-summary]');
			this.$placeOrderBtn = '#place_order';
			this.hasAttemptedNextStep = false;

			this.isNextStepLoading = false;

			// Fields
			this.$billingCompany = $('input[name="billing_company"]');
			this.$billingOib = $('input[name="billing_oib"]');
			this.$billingCountry = $('select[name="billing_country"]');
			this.$billingFirstName = $('input[name="billing_first_name"]');
			this.$billingLastName = $('input[name="billing_last_name"]');
			this.$billingAddress1 = $('input[name="billing_address_1"]');
			this.$billingAddress2 = $('input[name="billing_address_2"]');
			this.$billingCity = $('input[name="billing_city"]');
			this.$billingPostcode = $('input[name="billing_postcode"]');
			this.$billingPhone = $('input[name="billing_phone"]');
			this.$billingEmail = $('input[name="billing_email"]');

			this.$shippingCompany = $('input[name="shipping_company"]');
			this.$shippingOib = $('input[name="shipping_oib"]');
			this.$shippingFirstName = $('input[name="shipping_first_name"]');
			this.$shippingLastName = $('input[name="shipping_last_name"]');
			this.$shippingAddress1 = $('input[name="shipping_address_1"]');
			this.$shippingAddress2 = $('input[name="shipping_address_2"]');
			this.$shippingCity = $('input[name="shipping_city"]');
			this.$shippingPostcode = $('input[name="shipping_postcode"]');

			// Checkboxes
			this.$toggleR1 = $('#toggle_r1');
			this.$shipToDifferentAddressCheckbox = $('#ship-to-different-address-checkbox');

			// Summary
			this.$deliverySummary = $('[data-js="checkout-delivery-summary"]');
			this.$paymentSummary = $('[data-js="checkout-payment-summary"]');
			this.$customerDataSummary = $('[data-js="checkout-customer-data"]');
			this.$customerShippingDataSummary = $('[data-js="checkout-customer-shipping-data"]');
			this.lastCheckedNewsletterEmail = '';
		}

		bindEvents() {
			// Tab navigation events
			$(document).on('click', this.$nextStepBtn, (e) => this.handleNextStep(e));
			this.checkoutTabLinks.on('click', (e) => this.handleTabClick(e));
			$(document).on('click', '[data-js="order-summary-details-btn"]', (e) => this.toggleSummary(e));
			this.$editCustomerBtn.on('click', () => this.handleEditClick(0));
			this.$editDeliveryBtn.on('click', () => this.handleEditClick(1));
			this.$editPaymentBtn.on('click', () => this.handleEditClick(1));
			$(document).on('click', '[data-js-toggle-summary]', (e) => this.toggleSummary(e));
			this.$summaryCloseBtn.on('click', () => this.closeSummary());

			// Checkbox events
			this.$shipToDifferentAddressCheckbox.on('change', () => {
				this.checkValidation();
				this.customUpdateCheckout();
			});

			this.$toggleR1.on('change', () => {
				const r1Fields = $('#billing_company, #billing_oib');
				r1Fields[this.$toggleR1.is(':checked') ? 'attr' : 'removeAttr']('required', 'required');
				this.checkValidation();
			});

			// Methods that trigger update checkout
			this.$billingEmail.on('blur', () => this.checkNewsletterSubscription());
			this.$billingPostcode.on('blur', () => {
				if (this.$billingPostcode.val().trim() !== '') {
					this.customUpdateCheckout();
				}
			});

			$(document).on('blur', 'input[name="shipping_postcode"]', () => {
				if (this.$shipToDifferentAddressCheckbox.is(':checked')) {
					const shippingPostcode = $('input[name="shipping_postcode"]').val();
					if (shippingPostcode.trim() !== '') {
						this.customUpdateCheckout();
					}
				}
			});

			$(document).on('change', 'select[name="billing_country"]', () => this.customUpdateCheckout());
			$(document).on('change', 'select[name="shipping_country"]', () => {
				if (this.$shipToDifferentAddressCheckbox.is(':checked')) {
					this.customUpdateCheckout();
				}
			});

			$(document).on('updated_checkout', () => {
				setTimeout(() => {
					this.orderSummary.removeClass('order-summary--loading');
					$('.checkout__delivery').removeClass('checkout__delivery--loading');
				}, 200);
			});

			$('body').on('checkout_error', (e) => {
				setTimeout(() => {
					this.orderSummary.removeClass('order-summary--loading');
					$('.checkout__delivery').removeClass('checkout__delivery--loading');
				}, 200);

				const noticeGroup = $('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout').hide();
				const noticesWrapper = $('.woocommerce-notices-wrapper').first();

				noticeGroup.appendTo(noticesWrapper);
				noticeGroup.show();
			});

			$(document.body).on('change', 'input[name="ship_to_different_address"]', function () {
				var is_checked = $(this).is(':checked');

				if (is_checked) {
					$('.checkout__shipping-address').slideDown();
				} else {
					$('.checkout__shipping-address').slideUp();
				}

				// This tells WooCommerce to update totals/shipping methods
				$(document.body).trigger('update_checkout');
			});

			// Input events
			this.form.on('input blur', 'input, select, textarea', () => {
				setTimeout(() => this.checkValidation(), 50);
			});

			$(document).on('input', '.has-initial-value', (e) => $(e.currentTarget).removeClass('has-initial-value'));

			// Prevent form submission when pressing Enter key
			this.form.on('keypress', function (e) {
				if (e.which === 13) {
					return false;
				}
			});

			// Prevent event bubbling when clicking inside summary
			$(document).on('click', '.order-summary, .sticky-bar', function (e) {
				if (!e.target.closest('[data-dialog-close], .remove_coupon, [data-js="toggle-cart-details"]')) {
					e.stopPropagation();
				}
			});

			this.mediaQueryLg.addEventListener('change', () => this.closeSummary());

			// Update Summary
			$(document).on('ajaxComplete', (event, xhr, settings) => {
				if (settings.url.indexOf('wc-ajax=update_order_review') !== -1) {
					const fragments = xhr.responseJSON.fragments;

					if (fragments) {
						if (fragments.w4dOrderSummary) {
							$('.order-summary, .sticky-bar').replaceWith(fragments.w4dOrderSummary);
							this.orderSummary = $('.order-summary, .sticky-bar');
							this.$orderSummaryDetails = $('[data-js="order-summary-details"]');
						}

						if (fragments.w4dCheckoutStepTwo) {
							const $fragment = $(fragments.w4dCheckoutStepTwo);
							if ($('#checkout-tab-2').attr('aria-selected') === 'true') {
								$fragment.attr('aria-hidden', 'false');
							}
							$('#checkout-panel-2').replaceWith($fragment);
							$('#checkout-panel-2 .form__section').removeClass('form__section--loading');
						}

						$(document.body).trigger('updated_checkout');
						this.toggleNextStepBtn(false);
					}
				}
			});

			// Shipping method changes
			this.checkoutTabsContentWrapper.on('change', 'input[name="shipping_method[0]"]', () => {
				this.orderSummary.addClass('order-summary--loading');
				$('#checkout-panel-2 .form__section').addClass('form__section--loading');
				$('.checkout__delivery').addClass('checkout__delivery--loading');
				this.toggleNextStepBtn(true);
				this.updateDeliverySummary();
			});

			// Payment method changes
			this.checkoutTabsContentWrapper.on('change', 'input[name="payment_method"]', () => {
				this.orderSummary.addClass('order-summary--loading');
				$('#checkout-panel-2 .form__section').addClass('form__section--loading');
				$('.checkout__delivery').addClass('checkout__delivery--loading');
				this.toggleNextStepBtn(true);
				$(document.body).trigger('update_checkout');
				this.updatePaymentSummary();
			});

			$(window).on('resize', () => this.closeSummary());
		}

		customUpdateCheckout() {
			this.orderSummary.addClass('order-summary--loading');
			this.toggleNextStepBtn(true);
			$('body').trigger('update_checkout');
		}

		toggleNextStepBtn(disabled = true) {
			this.isNextStepLoading = disabled;
			$(this.$nextStepBtn).prop('disabled', disabled);

			if (!disabled) {
				this.checkValidation();
			}
		}

		checkValidation() {
			const currentTab = this.checkoutTabLinks.filter('[aria-selected="true"]');
			const currentStepIndex = currentTab.closest('li').index();
			const currentStepContent = this.checkoutTabsContentWrapper.children().eq(currentStepIndex);

			let isCurrentStepValid = this.validateStep(currentStepContent);
			let arePreviousStepsValid = true;

			// Check all previous steps to ensure they're still valid
			for (let i = 0; i < currentStepIndex; i++) {
				const previousStepContent = this.checkoutTabsContentWrapper.children().eq(i);
				if (!this.validateStep(previousStepContent)) {
					arePreviousStepsValid = false;
					break;
				}
			}

			const isValid = isCurrentStepValid && arePreviousStepsValid;

			$(this.$nextStepBtn).prop('disabled', this.isNextStepLoading);

			$(this.$placeOrderBtn).prop('disabled', !isValid);
		}

		validateStep(stepContent) {
			let isValid = true;

			// Skip shipping fields validation if checkbox is unchecked
			let skipShipping = false;
			if (!this.$shipToDifferentAddressCheckbox.is(':checked')) {
				const shippingFields = stepContent
					.find('[data-js-shipping-fields]')
					.find('input[required], select[required], textarea[required]');

				shippingFields.each(function () {
					$(this).data('temp-required', 'true');
					$(this).removeAttr('required');
				});
				skipShipping = true;
			}

			let skipR1 = false;
			if (!this.$toggleR1.is(':checked')) {
				const r1Fields = stepContent.find('#billing_company, #billing_oib');

				r1Fields.each(function () {
					$(this).data('temp-required', 'true');
					$(this).removeAttr('required');
				});
				skipR1 = true;
			}

			// Get all required fields in this step
			const requiredFieldsInStep = stepContent.find('input[required], select[required], textarea[required]');
			const validator = this.form.validate();

			// Check if all required fields have values
			requiredFieldsInStep.each((index, el) => {
				const $field = $(el);
				const fieldType = $field.attr('type');
				let isFieldValid = true;

				// Handle different field types
				if (fieldType === 'checkbox' || fieldType === 'radio') {
					const name = $field.attr('name');
					if (!stepContent.find(`input[name="${name}"]:checked`).length) {
						isFieldValid = false;
					}
				} else if ($field.is('select')) {
					if (!$field.val()) {
						isFieldValid = false;
					}
				} else {
					// Text inputs, email, tel, etc.
					if (!$.trim($field.val())) {
						isFieldValid = false;
					}
				}

				if (isFieldValid) {
					// If it passed manual check, check validator
					if (this.hasAttemptedNextStep) {
						if (!validator.element($field)) {
							isFieldValid = false;
						}
					} else if (typeof validator.check === 'function') {
						if (!validator.check($field[0])) {
							isFieldValid = false;
						}
					}
				} else if (this.hasAttemptedNextStep) {
					// Manual check failed, trigger error message
					validator.element($field);
				}

				if (!isFieldValid) {
					isValid = false;
					// If no attempt made, break early for performance
					if (!this.hasAttemptedNextStep) {
						return false;
					}
				}
			});

			// Restore required attributes for shipping fields
			if (skipShipping) {
				const shippingFields = stepContent.find('[data-js-shipping-fields]').find('input, select, textarea');

				shippingFields.each(function () {
					if ($(this).data('temp-required')) {
						$(this).attr('required', 'required');
						$(this).removeData('temp-required');
					}
				});
			}

			// Restore required attributes for R1 fields
			if (skipR1) {
				const r1Fields = stepContent.find('#billing_company, #billing_oib');

				r1Fields.each(function () {
					if ($(this).data('temp-required')) {
						$(this).attr('required', 'required');
						$(this).removeData('temp-required');
					}
				});
			}

			return isValid;
		}

		handleNextStep() {
			this.hasAttemptedNextStep = true;
			const currentTab = this.checkoutTabLinks.filter('[aria-selected="true"]');
			const nextTab = currentTab.closest('li').next().find('.checkout-tabs__tab');
			const currentTabIndex = currentTab.closest('li').index();

			if (this.checkoutForm.valid() === false && currentTabIndex === 0) {
				const $firstError = this.checkoutForm.find('.field__error-msg:visible').first();
				if ($firstError.length) {
					let bottomOffset = 80;
					if (this.form.hasClass('checkout--2')) {
						const stickyBarHeight = $('.sticky-bar').outerHeight() || 0;
						bottomOffset += stickyBarHeight;
					}

					const errorTop = $firstError.offset().top;
					const errorBottom = errorTop + $firstError.outerHeight();
					const windowScrollTop = $(window).scrollTop();
					const windowHeight = $(window).height();

					// If error is below current viewport (or hidden by sticky bottom bar),
					// scroll DOWN so it's [bottomOffset] from bottom.
					if (errorBottom > windowScrollTop + windowHeight - bottomOffset) {
						const targetScroll = errorBottom - windowHeight + bottomOffset;
						if (targetScroll > windowScrollTop) {
							window.W4D_Pagination.smoothScrollToTop(targetScroll, 0);
						}
					}
					// If error is above current view or under sticky header (80px),
					// scroll UP so it's 80px from top.
					else if (errorTop < windowScrollTop + 80) {
						window.W4D_Pagination.smoothScrollToTop($firstError, 80);
					}

					// Focus the input within the same field
					const $input = $firstError.closest('.field').find('input, select, textarea').first();
					if ($input.length) {
						setTimeout(() => $input.focus(), 600); // Focus after scroll animation
					}
				} else {
					window.W4D_Pagination.smoothScrollToTop(this.$header, 0);
				}
				return;
			}

			currentTab.addClass('checkout-tabs__tab--complete');

			// Mark current tab as checked and enable it for going back
			currentTab.attr('aria-disabled', 'false').prop('disabled', false);

			if (nextTab.length) {
				// Enable next tab and remove disabled state
				nextTab.attr('aria-disabled', 'false').prop('disabled', false);
				this.changeTab(nextTab);
			}
		}

		handleEditClick(tabIndex) {
			this.goToSpecificTab(tabIndex);
		}

		formatAddress() {
			let address = this.$billingAddress1.val();
			const address2 = this.$billingAddress2.val();

			if (address2 && address2.trim() !== '') {
				address += ` ${address2}`;
			}

			return address;
		}

		formatShippingAddress() {
			let address = this.$shippingAddress1.val();
			const address2 = this.$shippingAddress2.val();

			if (address2 && address2.trim() !== '') {
				address += ` ${address2}`;
			}

			return address;
		}

		/* ----------------------> Summary <---------------------- */

		toggleSummary(e) {
			const $btn = $(e.currentTarget);
			const isExpanded = $btn.attr('aria-expanded') === 'true';
			const newState = !isExpanded;

			const oldDocHeight = $(document).height();
			const scrollTop = $(window).scrollTop();
			const winHeight = $(window).height();

			const isAtBottom = scrollTop + winHeight >= oldDocHeight - 10;

			$btn.attr('aria-expanded', newState);
			this.$orderSummaryDetails.attr('aria-hidden', !newState);

			const label = newState ? $btn.data('hide') : $btn.data('show');
			$btn.text(label);

			// Handle the "Push Down" effect if opening while at the bottom
			if (newState && isAtBottom) {
				// Wait a frame for the DOM to calculate the new height
				requestAnimationFrame(() => {
					const newDocHeight = $(document).height();

					$('html, body').stop().animate(
						{
							scrollTop: newDocHeight,
						},
						400
					); // Matching the 0.4 s CSS transition
				});
			}
		}

		closeSummary() {
			const dialog = document.querySelector('dialog[data-modal="order-summary"][open]');
			if (dialog) {
				dialog.close();
			}
		}

		/* ----------------------> Update Summary Data <---------------------- */

		updateCustomerPersonalDataSummary() {
			// Store the first <li> (title) from billing data
			const billingTitle = this.$customerDataSummary.find('li:first').prop('outerHTML');

			const customerData = {
				billing_company: this.$billingCompany.val(),
				billing_oib: this.$billingOib.val(),
				name: `${this.$billingFirstName.val()} ${this.$billingLastName.val()}`,
				email: this.$billingEmail.val(),
				address: this.formatAddress(),
				cityPostal: `${this.$billingPostcode.val()} ${this.$billingCity.val()}`,
			};

			let summaryHTML = billingTitle;
			if ($(this.$toggleR1).length) {
				if ($(this.$toggleR1).prop('checked')) {
					summaryHTML += `
                    <li>${customerData.billing_company}</li>
                    <li>${customerData.billing_oib}</li>`;
				} else {
					this.$billingCompany.val('');
					this.$billingOib.val('');
				}
			} else if (customerData.billing_company !== undefined && customerData.billing_oib !== undefined) {
				summaryHTML += `
                    <li>${customerData.billing_company}</li>
                    <li>${customerData.billing_oib}</li>`;
			}

			summaryHTML += `
                <li>${customerData.name}</li>
                <li>${customerData.address}</li>
                <li>${customerData.cityPostal}</li>
                <li>${customerData.email}</li>`;
			this.$customerDataSummary.html(summaryHTML);

			if (this.$shipToDifferentAddressCheckbox.is(':checked')) {
				let shippingSummaryHTML = this.$customerShippingDataSummary.find('li:first').prop('outerHTML');

				const shippingData = {
					name: `${this.$shippingFirstName.val()} ${this.$shippingLastName.val()}`,
					address: this.formatShippingAddress(),
					cityPostal: `${this.$shippingPostcode.val()} ${this.$shippingCity.val()}`,
					shipping_company: this.$shippingCompany.val(),
					shipping_oib: this.$shippingOib.val(),
				};

				if (shippingData.shipping_company !== undefined && shippingData.shipping_oib !== undefined) {
					shippingSummaryHTML += `
                        <li>${shippingData.shipping_company}</li>
                        <li>${shippingData.shipping_oib}</li>`;
				}

				shippingSummaryHTML += `
                    <li>${shippingData.name}</li>
                    <li>${shippingData.address}</li>
                    <li>${shippingData.cityPostal}</li>`;
				this.$customerShippingDataSummary.html(shippingSummaryHTML).attr('aria-hidden', 'false');
			} else {
				// Keep only the title when checkbox is unchecked
				const shippingTitle = this.$customerShippingDataSummary.find('li:first').prop('outerHTML');
				this.$customerShippingDataSummary.html(shippingTitle || '').attr('aria-hidden', 'true');
			}
		}

		updateDeliverySummary() {
			const selectedShipping = $('input[name="shipping_method[0]"]:checked');

			const labelText = selectedShipping.data('label');
			const costDisplay = selectedShipping.data('cost-display');

			let deliveryHTML = `<p class="checkout__delivery-summary-title">${labelText}</p>`;
			if (costDisplay) {
				deliveryHTML += `<p class="checkout__delivery-summary-description">${costDisplay !== 'Besplatno' ? `Cijena dostave: ${costDisplay}` : 'Besplatna dostava'}</p>`;
			}

			this.$deliverySummary.html(deliveryHTML);
		}

		updatePaymentSummary() {
			const selectedPayment = $('input[name="payment_method"]:checked');

			const labelText = selectedPayment.data('label');
			const helperText = selectedPayment.data('helper-text');

			const paymentHTML = `<p class="checkout__delivery-summary-title">${labelText}</p><div class="checkout__delivery-summary-description">${helperText}</div>`;

			this.$paymentSummary.html(paymentHTML);
		}

		/* -----------------------> Tabs <------------------------ */

		updateCheckoutTitle(index) {
			// Only update title if checkout form has checkout--2 class
			if (!this.checkoutForm.hasClass('checkout--2')) {
				return;
			}

			if (!this.$checkoutStepTitle.length) {
				return;
			}

			const stepTitle = this.$checkoutStepTitle.data(`step-${index}`);
			if (stepTitle) {
				this.$checkoutStepTitle.text(stepTitle);
			}
		}

		handleTabClick(e) {
			const $target = $(e.target).closest('button');

			// Check both aria-disabled attribute and disabled property
			if ($target.attr('aria-disabled') === 'true' || $target.prop('disabled')) {
				e.preventDefault();
				return false;
			}

			this.tabTrigger(e);
		}

		showTabContent(index) {
			// Hide all panels and set aria-hidden
			this.checkoutTabsContentWrapper.children().attr('aria-hidden', 'true');
			// Show active panel and remove aria-hidden
			this.checkoutTabsContentWrapper.children().eq(index).attr('aria-hidden', 'false');
		}

		tabTrigger(e) {
			e.preventDefault();
			const $el = $(e.target).closest('button');
			this.changeTab($el);
		}

		tabActiveNav($el) {
			// Update ARIA attributes for all tabs
			this.checkoutTabLinks.attr('aria-selected', 'false');

			// Set active tab
			$el.attr('aria-selected', 'true');
		}

		goToSpecificTab(index) {
			const targetTab = this.checkoutTabLinks.eq(index);
			if (targetTab.length && targetTab.attr('aria-disabled') !== 'true' && !targetTab.prop('disabled')) {
				this.changeTab(targetTab);
			}
		}

		changeTab($tabLink) {
			const index = $tabLink.closest('li').index();
			this.tabActiveNav($tabLink);
			this.showTabContent(index);
			this.updateCheckoutTitle(index);
			this.checkValidation();
			window.W4D_Pagination.smoothScrollToTop(this.$header, 0);

			if (index === 2) {
				this.updateCustomerPersonalDataSummary();
				this.updateDeliverySummary();
				this.updatePaymentSummary();
				this.checkNewsletterSubscription();
			}
		}

		checkNewsletterSubscription() {
			const $wrapper = $('.js-newsletter-optin-wrapper');
			if (!$wrapper.length) {
				return;
			}

			const email = $.trim(this.$billingEmail.val());
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (!email || !emailRegex.test(email)) {
				$wrapper.show();
				this.lastCheckedNewsletterEmail = '';
				return;
			}

			if (this.lastCheckedNewsletterEmail === email) {
				return;
			}

			const ajaxUrl = window.w4d_frontend_ajax?.ajax_url || window.wc_checkout_params?.ajax_url || '/wp-admin/admin-ajax.php';
			const nonce = window.w4d_frontend_ajax?.nonce || '';

			$.ajax({
				url: ajaxUrl,
				type: 'POST',
				data: {
					action: 'w4d_check_newsletter_subscription',
					nonce: nonce,
					email: email,
				},
				success: (response) => {
					this.lastCheckedNewsletterEmail = email;
					if (response && response.success) {
						if (response.data && response.data.subscribed) {
							$wrapper.hide().find('input[type="checkbox"]').prop('checked', false);
						} else {
							$wrapper.show();
						}
					}
				},
			});
		}
	}

	$(document).ready(() => new W4D_Checkout());
})(jQuery);
